import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth';
import { retrieveSessionTokenFromSessionStorage } from '../api';

interface Props {
  children?: React.ReactElement;
  component: React.ReactElement;
}

export const ProtectedRoute = ({ children, component }: Props) => {
  const { pathname, search } = useLocation();
  const { user } = useAuth();

  if (!retrieveSessionTokenFromSessionStorage() || !user)
    return <Navigate to={`/login?${search}`} state={{ redirectTo: pathname + search }} />;

  if (children) return children;
  if (component) return component;

  return <></>;
};
